
<form #f="ngForm" (ngSubmit)="saveResource()">
    <div class="p-grid">  
        <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
        <div class="p-col-12 error-notify-text">
            <app-validateform [formToValidate]="addResourceForm"></app-validateform>
        </div>
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
                    <button pButton type="submit" class="fullwidthbtn" label="Save"></button>
                </div>
                <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
                    <button pButton type="button" class="fullwidthbtn" label="Cancel"
                        (click)="cancelAddResource()"></button>
                </div>
            </div>
            <div>
                <p-panel header="RESOURCE CATEGORY">
                    <div class="p-col-12">
                        <p-listbox [options]="resourcecategories" [group]="true" [(ngModel)]="selectedCategoryId"
                            [metaKeySelection]="false" [checkbox]="true" [filter]="true"
                            [listStyle]="{'max-height':'250px'}"  name="resourcecategories">
                            <ng-template let-group pTemplate="group">
                                <div class="p-d-flex p-ai-center">
                                    <span><b>{{group.label}}</b></span>
                                </div>
                            </ng-template>
                        </p-listbox>
                    </div>
                </p-panel>

                <p-panel header="RESOURCE">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text" pInputText [(ngModel)]="ResourceName" name="Name"
                                    requiredNoSpaceValidator data-display-name="Name" />
                                <label for="float-input">Name*</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <p-editor placeholder="Description" [(ngModel)]="Description" [style]="{'height':'200px'}"
                                name="Description"></p-editor>
                        </div>
                    </div>
                </p-panel>
                <p-panel header="ATTACHMENTS">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-12 p-md-12">                           
                            <div class="card" [hidden]="IsDocuments()">
                                <strong>Existing Attachments:</strong>
                                <div class="ui-g">
                                    <div class="p-col-12">
                                        <p-table [value]="Documents" dataKey="Id" [rows]="20" [responsive]="true"
                                            [resizableColumns]="true">

                                            <ng-template pTemplate="body" let-doc>
                                                <tr>
                                                    <td> <a class="hyperLink" (click)="OpenUrl(doc)">{{doc.Title}}</a>
                                                    </td>
                                                    <td>
                                                        <span [class]=" getIcon(doc) + ' fiv-size-md '"></span>
                                                    </td>
                                                    <td>
                                                        <button pButton type="button" pRipple icon="pi pi-trash"
                                                            class="p-button-rounded"
                                                            (click)="deleteDocument(doc)"></button>
                                                    </td>
                                                </tr>
                                            </ng-template>

                                        </p-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12">
                            <p-fileUpload name="myfile[]" url="{{uploadURL}}" multiple="multiple"
                                chooseLabel="Add Files" [showUploadButton]="false"
                                (onBeforeUpload)="onBeforeUpload($event)" (onUpload)="onUploadCompleted($event)">
                            </p-fileUpload>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-12 p-md-12">                                
                                 <div class="p-grid">
                                    <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
                                        <button pButton pRipple type = "button" label="Add Link" icon="pi pi-plus"  (click)="openNew()"></button>      
                                    </div>                                          
                                    </div> 
                                   
                                    <div class="p-col-12">                                        
                                        <p-table [value]="Links" dataKey="Id" [rows]="20" [responsive]="true"
                                            [resizableColumns]="true">

                                            <ng-template pTemplate="body" let-doc>
                                                <tr>
                                                    <td> <a class="hyperLink"
                                                        (click)="OpenUrl(doc)">{{doc.Title}}</a></td>
                                                    <td>
                                                        <button pButton pRipple icon="pi pi-trash"
                                                            class="p-button-rounded"
                                                            (click)="deleteLink(doc)"></button>
                                                    </td>
                                                </tr>
                                            </ng-template>

                                        </p-table>
                                    </div>                                  
                                </div>
                            
                        </div>
                    </div>
                </p-panel>
            </div>
        </div>
    </div>
</form>

<p-dialog draggable="false" modal="true"  [(visible)]="linkDialog" [style]="{width: '450px'}" header="Add Link" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        
        <div class="p-field">
            <label for="Title">Title</label>
            <input type="text" pInputText id="title" [(ngModel)]="link.Title" required autofocus />
            <small class="p-error" *ngIf="submitted && !link.Title">Title is required.</small>
        </div>
        <div class="p-field">
            <label for="URI">URL</label>
            <input type="text" pInputText id="uri" [(ngModel)]="link.DocumentURI" required autofocus />
            <small class="p-error" *ngIf="submitted && !link.Uri">Url is required.</small>
        </div>
    </ng-template>
    
    <ng-template pTemplate="footer">
        <button pButton type="button" pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple type="button" label="Save" icon="pi pi-check" class="p-button-text" (click)="saveLink()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog header="Confirmation" key="AddResourceConfirmationDialog" icon="pi pi-exclamation-triangle">
</p-confirmDialog>
